module.exports = __webpack_public_path__ + "static/media/header_logo.053673be.svg";